import React from 'react'
import { Box, Typography, Radio, styled, useTheme } from '@mui/material'
import { Icon } from '../../eid-icons'
import { StyledTreeItem } from './StyledTreeItem'

const StyledRadio = styled(Radio)({
    padding: '2px',
    maxHeight: '20px',
    '&:hover': {
        backgroundColor: '#d2d2d9',
    },
})

const highlight = (text, searchKey) => {
    searchKey = new RegExp('(' + searchKey + ')', 'gi')
    return text.split(searchKey).map((o, i) =>
        i % 2 === 1 ? (
            <span className="search-highlight" key={i}>
                {o}
            </span>
        ) : (
            o
        ),
    )
}

const TreeItem = React.forwardRef(
    (
        {
            index,
            label,
            count,
            highlightText,
            selected,
            onClick,
            radioSelection = true,
            iconUrl,
            isParentSelected,
            isRoot,
            ...rest
        },
        ref,
    ) => {
        const theme = useTheme()

        let labelToShow

        if (highlightText && highlightText.length) {
            labelToShow = highlight(label, highlightText)
        } else {
            labelToShow = label
        }

        return (
            <StyledTreeItem
                ref={ref}
                radioSelection={radioSelection}
                selected={selected}
                isParentSelected={isParentSelected}
                {...rest}
                label={
                    <Box
                        padding={radioSelection ? '0px' : '5px'}
                        display="flex"
                        height="100%"
                        alignItems="center"
                        onClick={(e) => {
                            if (!radioSelection) {
                                e.preventDefault()
                                onClick(e)
                            } else {
                                onClick(e)
                            }
                        }}
                    >
                        {radioSelection && (
                            <StyledRadio
                                checkedIcon={
                                    <Icon
                                        name="RadioFilled"
                                        color={theme.palette.primary.main}
                                    />
                                }
                                icon={<Icon name="Radio" />}
                                checked={selected ?? false}
                                onClick={onClick}
                            />
                        )}
                        {iconUrl && (
                            <img
                                style={{ maxHeight: '16px' }}
                                src={iconUrl}
                                alt=""
                                aria-hidden="true"
                            />
                        )}
                        <Typography
                            variant="body2"
                            style={{
                                fontWeight: isRoot ? 'bold' : 'normal',
                                wordBreak: 'break-all',
                                paddingLeft: '12px',
                            }}
                        >
                            {labelToShow}
                        </Typography>
                        {count !== undefined && (
                            <Typography
                                variant="body2"
                                style={{ marginLeft: '5px', color: '#919193' }}
                            >
                                ({count})
                            </Typography>
                        )}
                        {!radioSelection && (selected || isParentSelected) && (
                            <Box
                                style={{
                                    marginLeft: '17px',
                                    marginRight: '8px',
                                }}
                            >
                                <Icon name="Check" color={'#00bb75'} />
                            </Box>
                        )}
                    </Box>
                }
            />
        )
    },
)

TreeItem.displayName = 'TreeItem'

export default TreeItem
